import React, { useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../Utils/helper";

const PhoneInputProps = React.memo(({ value, onChange, readOnly = false, className }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const hasFocused = useRef(false);

  const formatPhoneNumber = (phone) => {
    const cleaned = phone.replace(/[^0-9]/g, "");
    const formatted =
      cleaned.length > 4 ? `${cleaned.slice(0, 4)}-${cleaned.slice(4, 8)}` : cleaned;
    return formatted;
  };

  const handleInputChange = useCallback(
    (e) => {
      const formattedPhone = formatPhoneNumber(e.target.value);
      onChange(formattedPhone);
    },
    [onChange]
  );

  useEffect(() => {
    if (readOnly) return; // nếu readonly → không focus
    if (hasFocused.current) return; // chỉ focus lần đầu
    if (!inputRef.current) return;

    // Delay cực nhỏ để Framer Motion hoàn thành mount trước
    const timer = setTimeout(() => {
      inputRef.current?.focus();
      hasFocused.current = true;
    }, 150); // 100–200ms là đủ để animation mượt

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cn(
        "flex items-center bg-white rounded-lg px-3 py-2 border border-light-grey",
        className
      )}
    >
      <div className="flex gap-[6px]  h-full items-center border-r pr-1">
        <div className="w-6 flex justify-center items-center text-[#06C755]">
          <span className="icon icon-whatsapp text-xl" />
        </div>
        <div className="text-mid-gray font-medium text-sm">+65</div>
        <div className="">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3 w-3 text-mid-gray"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={handleInputChange}
        className="outline-none w-full bg-transparent ml-2 placeholder:text-mid-gray"
        placeholder={t("signUp.whatsAppNumber")}
        readOnly={readOnly}
      />
    </div>
  );
});

export default PhoneInputProps;
